import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AuthProvider from '@/contexts/AuthContext';
import ProtectedRoute from '@/components/ProtectedRoute';
import AppLayout from '@/components/Layout/AppLayout';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import Dashboard from '@/pages/Dashboard';
import WorkRecords from '@/pages/WorkRecords';
import Projects from '@/pages/Projects';
import ProjectCosts from '@/pages/ProjectCosts';
import ProjectRevenues from '@/pages/ProjectRevenues';
import Reports from '@/pages/Reports';
import Users from '@/pages/Users';
import AdminWorkLogs from '@/pages/AdminWorkLogs';
import TeamLogs from '@/pages/TeamLogs';
import AllLogs from '@/pages/AllLogs';
import { useAuth } from '@/contexts/AuthContext';

const DefaultRoute: React.FC = () => {
  const { user, isLoading } = useAuth();
  
  // Wait for auth to complete
  if (isLoading) {
    return <div>Loading...</div>;
  }
  
  // If no user (shouldn't happen in protected route), fallback to dashboard
  if (!user) {
    return <Dashboard />;
  }
  
  // Debug: log user role
  console.log('User role:', user.role);
  
  // Admin users see dashboard, all others go to work records
  if (user.role === 'admin') {
    return <Dashboard />;
  } else {
    return <Navigate to="/work-records" replace />;
  }
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <AppLayout>
                <Routes>
                  <Route path="/" element={<DefaultRoute />} />
                  <Route path="/dashboard" element={<DefaultRoute />} />
                  <Route path="/work-records" element={<WorkRecords />} />
                  <Route path="/projects" element={<Projects />} />
                  <Route path="/project-costs" element={<ProjectCosts />} />
                  <Route path="/project-revenues" element={<ProjectRevenues />} />
                  <Route path="/reports" element={<Reports />} />
                  <Route path="/users" element={<Users />} />
                  <Route path="/admin/work-logs" element={<AdminWorkLogs />} />
                  <Route path="/team-logs" element={<TeamLogs />} />
                  <Route path="/all-logs" element={<AllLogs />} />
                </Routes>
              </AppLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </AuthProvider>
  );
};

export default App;